<template>
  <date-range-picker
    v-model="period"
    :locale-data="locale"
    :ranges="ranges"
    :date-format="dateFormat"
    :opens="opens"
    :class="['w-full sm:w-auto kompack-date-container', containerClass]"
  >
    <template v-slot:input="picker">
      <slot
        name="default"
        :data="picker"
      >
        <div :class="['d-flex justify-between gap-[14px] items-center w-100 p-[3px]', inputContainerClass]">
          <span :class="inputLabelClass">
            {{ getFormattedDateRange(picker.startDate, picker.endDate) }}
          </span>
          <span class="k-calendar text-[24px]" />
        </div>
      </slot>
    </template>
  </date-range-picker>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { today } from '@/store/helpers'
import { locale, datePickerRangeGeneral } from './config'
import { getFormattedDateRange } from './helpers'

export default {
  components: {
    DateRangePicker,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    inputContainerClass: {
      type: String,
      default: '',
    },
    inputLabelClass: {
      type: String,
      default: 'text-[14px] text-[#6e6b7b]',
    },
    dateFormat: {
      type: Function,
      default: null,
    },
    ranges: {
      type: Object,
      default: () => datePickerRangeGeneral(today),
    },
    opens: {
      type: String,
      default: 'left',
    },
    containerClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      locale,
      period: this.value,
    }
  },
  watch: {
    period(newValue) {
      this.$emit('input', newValue)
    },
  },
  methods: {
    getFormattedDateRange,
  },
}
</script>

    <style>
    .kompack-date-container .form-control {
        border-color: #e2e2e2;
        border-radius: 8px;
    }
    </style>
